<script>
import { RectangleStencil } from 'vue-advanced-cropper';

const HEART_PATH = 'M 82.935559,1.9669129 C 70.669288,-2.9605241 56.935705,1.6864169 50.000041,12.37241 43.065048,1.6864169 29.330801,-2.9605241 17.064184,1.9669129 3.1270197,7.5663249 -3.6317978,23.405074 1.9679446,37.34158 7.3370178,50.707442 49.879698,84.014019 49.879698,84.014019 l 0.119993,0.09351 0.120267,-0.09351 c 0,0 42.541692,-33.306577 47.911754,-46.672439 C 103.63216,23.405074 96.873016,7.5663249 82.935532,1.9669129 Z';

export default {
  name: 'HeartStencil',
  extends: RectangleStencil,
  methods: {
    aspectRatios() {
      const max = 100;
      return {
        minimum: 1 / max,
        maximum: max,
      };
    },
    processCrop(canvas) {
      const context = canvas.getContext('2d');
      const { width } = canvas;
      const { height } = canvas;
      const pathSize = { w: 100, h: 84.1 };

      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.scale(1, height / width);
      // This path's size is 1235x1175. Calculating this is not easy, so we just have to know beforehand
      const heartPath = new Path2D(HEART_PATH);
      const heartPathScaled = new Path2D();
      const matrix = document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGMatrix();
      heartPathScaled.addPath(heartPath, matrix.scaleNonUniform(width / pathSize.w, width / pathSize.h));
      context.fill(heartPathScaled);
      context.closePath();
      return canvas;
    },
  },
};
</script>
<style scoped lang="scss">
$border-radius: 50% 50% 0 0;
.vue-rectangle-stencil {
  ::v-deep &__preview {
    /** Polygon obtained by
    1. Converting curves to polygon (inkscape)
    2. Converting svg polygon to css polygon with percentages (https://betravis.github.io/shape-tools/path-to-polygon/)
    */
    clip-path: polygon(82.9356% 2.3386%, 80.6205% 1.3726%, 78.2831% 0.667%, 75.9355% 0.216%,
     73.5899% 0.0134%, 71.2583% 0.0529%, 68.9528% 0.3285%, 66.6857% 0.834%, 64.4688% 1.5631%,
     62.3145% 2.5097%, 60.2347% 3.6678%, 58.2416% 5.0311%, 56.3473% 6.5936%, 54.5638% 8.3489%,
     52.9034% 10.2909%, 51.3781% 12.4136%, 50.0% 14.7108%, 48.6221% 12.4136%, 47.0968% 10.2909%,
     45.4365% 8.3489%, 43.6531% 6.5936%, 41.7588% 5.0311%, 39.7657% 3.6678%, 37.6859% 2.5097%,
     35.5315% 1.5631%, 33.3146% 0.834%, 31.0473% 0.3285%, 28.7418% 0.0529%, 26.4102% 0.0134%,
     24.0645% 0.216%, 21.7168% 0.667%, 19.3794% 1.3726%, 17.0642% 2.3386%, 14.5364% 3.7261%,
     12.1843% 5.3777%, 10.0158% 7.2725%, 8.0382% 9.3891%, 6.2592% 11.7064%, 4.6864% 14.2034%,
     3.3274% 16.8588%, 2.1897% 19.6516%, 1.281% 22.5606%, 0.6088% 25.5645%, 0.1808% 28.6422%,
     0.0044% 31.7727%, 0.0874% 34.9348%, 0.4372% 38.1073%, 1.0616% 41.2692%, 1.9679% 44.3992%,
     3.3908% 47.6413%, 5.5682% 51.3464%, 8.3832% 55.4217%, 11.7192% 59.7745%, 15.4594% 64.3119%,
     19.487% 68.9414%, 27.9372% 78.1054%, 36.1358% 86.5245%, 43.1485% 93.4566%, 49.8797% 99.8926%,
     49.9997% 100.0038%, 50.12% 99.8926%, 56.851% 93.4566%, 63.8636% 86.5245%, 72.0621% 78.1054%,
     80.5122% 68.9414%, 84.5398% 64.3119%, 88.28% 59.7745%, 91.6161% 55.4217%, 94.4312% 51.3464%,
     96.6087% 47.6413%, 98.0317% 44.3992%, 98.9382% 41.2692%, 99.5626% 38.1073%, 99.9126% 34.9348%,
     99.9956% 31.7727%, 99.8193% 28.6422%, 99.3912% 25.5645%, 98.7191% 22.5606%, 97.8103% 19.6516%,
     96.6727% 16.8588%, 95.3136% 14.2034%, 93.7408% 11.7064%, 91.9617% 9.3891%, 89.9841% 7.2725%,
     87.8155% 5.3777%, 85.4634% 3.7261%, 82.9355% 2.3386%, 82.9356% 2.3386%);
  }

}

</style>
